import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, UsersIcon } from 'lucide-react';
export function Pricing() {
  const pricingPlans = [{
    title: 'Office Appointment',
    price: '65.25',
    description: 'Individual fingerprinting at our Columbia, MD office.',
    icon: BuildingIcon,
    highlight: false
  }, {
    title: 'Mobile / Group',
    price: '70.25',
    suffix: 'per person',
    description: 'On-site mobile service for groups of 5 or more.',
    icon: UsersIcon,
    highlight: true
  }];
  return <section id="pricing" className="py-12 lg:py-20 bg-slate-50 border-y border-slate-200/60" aria-labelledby="pricing-heading" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="text-center mb-16 lg:mb-20" data-id="element-175">
          <h2 id="pricing-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-176">
            Transparent Pricing
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full mb-8" aria-hidden="true" data-id="element-177"></div>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-178">
            All-inclusive pricing with no hidden fees. Our rates include all
            CJIS and government processing fees.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-179">
          {pricingPlans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-8 lg:p-12 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 border relative overflow-hidden flex flex-col ${plan.highlight ? 'border-[#4AA6CF]/30 ring-2 ring-[#4AA6CF]/5' : 'border-slate-200'}`} data-id="element-180">
              {plan.highlight && <div className="absolute top-0 right-0 bg-[#4AA6CF] text-white text-[10px] font-extrabold uppercase tracking-widest py-2 px-6 rounded-bl-2xl shadow-sm" data-id="element-181">
                  Best for Teams
                </div>}

              <div className="flex items-center gap-6 mb-8" data-id="element-182">
                <div className={`p-4 rounded-xl shadow-inner border border-slate-100 hover:shadow-2xl hover:shadow-slate-200 transition-all duration-500 ${plan.highlight ? 'bg-[#4AA6CF]/10 text-[#4AA6CF]' : 'bg-slate-50 text-slate-400'}`} data-id="element-183">
                  <plan.icon className="h-8 w-8" data-id="element-184" />
                </div>
                <h3 className="text-2xl font-extrabold text-slate-900 tracking-tight" data-id="element-185">
                  {plan.title}
                </h3>
              </div>

              <div className="mb-8" data-id="element-186">
                <div className="flex items-baseline gap-1" data-id="element-187">
                  <span className="text-6xl font-extrabold text-slate-900 tracking-tighter" data-id="element-188">
                    ${plan.price}
                  </span>
                  {plan.suffix && <span className="text-slate-500 font-medium text-base" data-id="element-189">
                      {plan.suffix}
                    </span>}
                </div>
              </div>

              <p className="text-slate-600 text-base mb-10 flex-grow leading-relaxed" data-id="element-190">
                {plan.description}
              </p>

              <a href="#/booking" className={`w-full py-5 rounded-full text-center font-extrabold text-lg transition-all ${plan.highlight ? 'bg-slate-900 text-white hover:bg-slate-800 shadow-xl hover:shadow-2xl' : 'bg-slate-100 text-slate-900 hover:bg-slate-200'}`} data-id="element-191">
                Book Now
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}